<template>
    <div class="card">
        <highcharts :options="chartOptions" class="container"></highcharts>
    </div>
</template>
<script>
import ColumnChart from "../Monitors/ColumnChart";

export default {
    components: {
        highcharts: ColumnChart
    },
    props: {
        subscriptions: {
            type: Object,
            default: []
        }
    },
    data() {
        return {
            chartOptions: {
                title: {
                    text: 'New customers by months (activated subscriptions)'
                },
                xAxis: {
                    categories: []
                },
                series: [{
                    animation: {
                        duration: 2000
                    },
                    name: 'Subscriptions',
                    color: '#4F7AFE',
                    data: Object.values(this.subscriptions)
                }]
            }
        }
    },
    mounted(){
        Object.keys(this.subscriptions).forEach((el)=>{
            this.chartOptions.xAxis.categories.push(new Date(el).toLocaleString('default', {month: 'long', year: "numeric"}))
        })
    }
}
</script>
